import React, { useState, useEffect } from 'react';
import { useMutation, gql } from '@apollo/client';

const ACTUALIZAR_STOCK = gql`
  mutation editarProducto(
    $id: ID!
    $nuevoNombre: String
    $nuevaImagen: String
    $nuevoCodigo: String
    $nuevoStock: Int
    $nuevoPrecio: Int
  ) {
    editarProducto(
      _id: $id
      nombre: $nuevoNombre
      imagen: $nuevaImagen
      codigo: $nuevoCodigo
      stock: $nuevoStock
      precio: $nuevoPrecio
    ) {
      _id
      nombre
      precio
      stock
      codigo
      imagen
    }
  }
`;

const NUEVO_PEDIDO = gql`
  mutation crearPedido(
    $estado: String
    $nombreCliente: String
    $direccionCliente: String
    $whatsappCliente: String
    $notaPedido: String
    $productos: String
  ) {
    crearPedido(
      estado: $estado
      nombreCliente: $nombreCliente
      direccionCliente: $direccionCliente
      whatsappCliente: $whatsappCliente
      notaPedido: $notaPedido
      productos: $productos
    ) {
      _id
      estado
      numeroPedido
      nombreCliente
      direccionCliente
      whatsappCliente
      notaPedido
      productos
    }
  }
`;

function FinalizarCompra(props) {
  const [estado, setEstado] = useState("esperando");
  const [nombreCliente, setNombreCliente] = useState("");
  const [direccionCliente, setDireccionCliente] = useState("");
  const [whatsappCliente, setWhatsappCliente] = useState("");
  const [notaPedido, setNotaPedido] = useState("");
  const [productos, setProductos] = useState("");
  const [nuevoPedido] = useMutation(NUEVO_PEDIDO);
  const [carritoLocal, setCarritoLocal] = useState([]);

  useEffect(() => {
    const carritoGuardado = JSON.parse(localStorage.getItem('carrito')) || [];
    setCarritoLocal(carritoGuardado);
  }, []);

  const [actualizarStock] = useMutation(ACTUALIZAR_STOCK);

  const handleCompraClick = async () => {
    // Restar la cantidad comprada del stock de cada producto en el carrito
    for (const producto of carritoLocal) {
      const { _id, nombre, imagen, codigo, precio, stock, cantidad } = producto;
  
      await actualizarStock({
        variables: {
          id: _id,
          nuevoNombre: nombre,
          nuevaImagen: imagen,
          nuevoCodigo: codigo,
          nuevoPrecio: precio,
          nuevoStock: stock - cantidad,
        },
      });
    }
   
    // Limpiar el carrito después de la compra
    localStorage.removeItem('carrito');
    setCarritoLocal([]);
  };

  const pedidoSubmit = async (e) => {
    e.preventDefault();
    const carritoString = JSON.stringify(carritoLocal);

    // Create a new order
    await nuevoPedido({
      variables: {
        estado,
        nombreCliente,
        direccionCliente,
        whatsappCliente,
        notaPedido,
        productos: carritoString,
      },
    });

    setNombreCliente("");
    setDireccionCliente("");
    setWhatsappCliente("");
    setNotaPedido("");

    handleCompraClick();
  };

  return (
    <div>
      {carritoLocal.length === 0 && (
        <div class="alert alert-success text-center" role="alert">
          <h4 class="alert-heading">Agrega productos al carrito</h4>
        </div>
      )}

      {carritoLocal.length > 0 && (
        <ul>
          {carritoLocal.map((producto, index) => (
            <li key={index}>
              <img src={producto.imagen} width="50px" alt="" />
              {producto.nombre} - ${producto.precio} x {producto.cantidad}
            </li>
          ))}
        </ul>
      )}

      {carritoLocal.length > 0 && (
        <form onSubmit={pedidoSubmit}>
          <input type="hidden" name={estado} value="esperando" />
          <h3>nombres</h3>
          <input placeholder='nombre completo' value={nombreCliente} onChange={evt => setNombreCliente(evt.target.value)} />
          <h3>Direccion</h3>
          <input placeholder='ejemplo: calle 123 #01-01' value={direccionCliente} onChange={evt => setDireccionCliente(evt.target.value)} />
          <h3>whatsapp(se usara para notificaciones del pedido)</h3>
          <input placeholder='ejemplo: 3010000000' value={whatsappCliente} onChange={evt => setWhatsappCliente(evt.target.value)} />
          <h3>Notas de pedido</h3>
          <input placeholder='ejemplo: informacion adicional del pedido' value={notaPedido} onChange={evt => setNotaPedido(evt.target.value)} />
          <input type="hidden" value={JSON.stringify(carritoLocal, null, 2)} />
          <br />
          <br />
          <button className="btn btn-salida">Crear pedido</button>
        </form>
      )}
    </div>
  );
}

export default FinalizarCompra;
